var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11 15c1.306 0 2.418.835 2.83 2H22c.552 0 1 .448 1 1s-.448 1-1 1h-8.171c-.412 1.166-1.523 2-2.829 2-1.306 0-2.417-.834-2.829-2H6c-.552 0-1-.448-1-1s.448-1 1-1h2.17c.412-1.165 1.524-2 2.83-2zm0 2c-.552 0-1 .448-1 1s.448 1 1 1c.55 0 .996-.443 1-.992v-.016l-.007-.109c-.057-.497-.48-.883-.993-.883zm6-10c1.306 0 2.418.835 2.83 2H22c.552 0 1 .448 1 1s-.448 1-1 1h-2.171c-.412 1.166-1.523 2-2.829 2-1.306 0-2.417-.834-2.829-2H6c-.552 0-1-.448-1-1s.448-1 1-1h8.17c.412-1.165 1.524-2 2.83-2zm0 2c-.552 0-1 .448-1 1s.448 1 1 1c.55 0 .996-.443 1-.992v-.016l-.007-.109C17.936 9.386 17.513 9 17 9z",
    transform: "translate(-392 -252) translate(45 162) translate(347 90)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.7f93aad8da765331cb11ca4a06a49d6d.svg";
export { ForwardRef as ReactComponent };